import TemplateView from '../../../../../TemplateView'

export default class EmptyList extends TemplateView {

    constructor() {
        super()

        this.state = {
            title: ''
        }

        this.onStatePropertyChanged('title', (title) => {
            this.$title.text(title)
        })
    }

    templateHtml() {
        return '    <div class="holidayPanelsEmptyList">' +
               '        <div class="img"/>' +
               '        <div class="title"/>' +
               '    </div>'
    }

    afterRender() {
        this.$title = this.find('.title')
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/components/EmptyList.js